import ENV from "config/Env";
import { backendQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { LandingPage, NotificationElement } from "models";

const component = "AccountSettings";

export const AccountSettingsQueryKeys = {
  notificationsList: backendQueryKey<NotificationElement[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/notification_elements/list" }),
  landingPages: permanentBackendQueryKey<LandingPage[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/landing_pages" })
};
